import { createSlice } from '@reduxjs/toolkit';
import initialState from './calendarEventInitialState';
import { _setCalendarEvent } from './calenderEventAction';

export const calendarEventSlice = createSlice({
  name: 'deltaSnp/calendarEvent',
  initialState,
  reducers: {
    setCalendarEvent: _setCalendarEvent,
    resetCalendarEvent: () => initialState,
  },
});

export const { setCalendarEvent, resetCalendarEvent } =
  calendarEventSlice.actions;

export default calendarEventSlice.reducer;
